import { useState, useEffect } from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import SetupPage from '../features/setupFlow/pages/setup/SetupPage'
import { useAuth } from '../contexts/AuthProvider'
import { HappyTaskLoadingLogo } from '../components/icons/HappyTaskLoadingLogo'
import { navigateToHome } from './navigateToHome'

function MainTransition() {
  const navigate = useNavigate()

  useEffect(() => {
    navigateToHome(navigate)
  }, [navigate])

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      gap: '24px',
      animation: 'fadeIn 0.3s ease-in'
    }}>
      <HappyTaskLoadingLogo />
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      `}</style>
    </div>
  )
}

export function SetupRoute() {
  const { isAuthenticated, loading } = useAuth()
  const { pathname } = useLocation()
  const [isCheckingSetupFlow, setIsCheckingSetupFlow] = useState(true)

  useEffect(() => {
    if (pathname !== '/') {
      setIsCheckingSetupFlow(false)
    }
  }, [pathname])

  const forceSetupPage = sessionStorage.getItem('forceSetupPage') === 'true'

  if (forceSetupPage) {
    sessionStorage.removeItem('forceSetupPage')
    return <SetupPage />
  }

  // Password recovery must take precedence over the setup-flow loading spinner.
  // Otherwise an authenticated user landing on '/' after clicking a recovery
  // link would be stuck on the HappyTask-Logo screen waiting for isCheckingSetupFlow
  // to flip (which never happens on '/').
  if (localStorage.getItem('passwordRecoveryMode') === 'true') {
    return <SetupPage />
  }

  if (loading || (isAuthenticated && pathname === '/' && isCheckingSetupFlow)) {
    return (
      <div style={{
        position: 'fixed',
        top: 'var(--window-titlebar-height, 48px)',
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '24px',
        animation: 'fadeIn 0.3s ease-in'
      }}>
        <HappyTaskLoadingLogo />
        <style>{`
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
        `}</style>
      </div>
    )
  }

  const offlineSetupCompleted = localStorage.getItem('offlineSetupCompleted') === 'true'
  const onboardingCompleted = localStorage.getItem('onboarding_completed') === 'true'

  if (offlineSetupCompleted && !isAuthenticated) {
    if (onboardingCompleted) {
      return <MainTransition />
    } else {
      return <Navigate to="/onboarding" replace />
    }
  }

  if (isAuthenticated) {
    const isPasswordRecovery = localStorage.getItem('passwordRecoveryMode') === 'true'

    if (isPasswordRecovery) {
      return <SetupPage />
    }

    if (pathname === '/') {
      setTimeout(() => setIsCheckingSetupFlow(false), 500)
      return (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '24px',
          animation: 'fadeIn 0.3s ease-in'
        }}>
          <HappyTaskLoadingLogo />
          <style>{`
            @keyframes fadeIn {
              from { opacity: 0; }
              to { opacity: 1; }
            }
          `}</style>
        </div>
      )
    }
  }

  return <SetupPage />
}
